import React, { useEffect, useReducer } from 'react';
import CrudListContainer from './CrudListContainer';
import CrudTreeContainer from './CrudTreeContainer';
import CrudEditContainer from './CrudEditContainer';
import CrudNewContainer from './CrudNewContainer';
import CrudShowContainer from './CrudShowContainer';

import './crud-view.scss';
import { JOKI } from '../../JOKI';

/**
 * Generic Crud Container that shows a list of elements and edit and new pages for a single item
 *
 * @param {*} props
 */
export default function CrudView(props) {
    const [crudState, dispatch] = useReducer(reducer, {
        viewMode: props.viewMode || 'LIST',
        item: null,
        serviceId: props.serviceId,
        form: props.form,
        columns: props.columns,
        title: props.title || 'CRUD',
        filters: props.filters || null,
        loading: true,
        editOnRowClick: typeof props.editOnRowClick === 'boolean' ? props.editOnRowClick : true,
        backTo: null,
    });

    useEffect(() => {
        dispatch({ type: 'filter', filters: props.filters });
    }, [props.filters]);

    useEffect(() => {
        return JOKI.on({
            from: props.serviceId,
            key: 'CrudStateUpdating',
            fn: event => {
                if (event.body) {
                    dispatch({ type: 'loadingOn' });
                } else {
                    dispatch({ type: 'loadingOff' });
                }
            },
        });
    }, [props.serviceId]);

    function crudDispatch(action = {}) {
        if (typeof action.type === 'string') {
            dispatch(action);
        }
    }
    return (
        <div className="main-view crud-view">
            {crudState.viewMode === 'LIST' && <CrudListContainer crudState={crudState} crudDispatch={crudDispatch} />}
            {crudState.viewMode === 'TREE' && <CrudTreeContainer crudState={crudState} crudDispatch={crudDispatch} />}

            {crudState.viewMode === 'SHOW' && <CrudShowContainer crudState={crudState} crudDispatch={crudDispatch} />}

            {crudState.viewMode === 'EDIT' && <CrudEditContainer crudState={crudState} crudDispatch={crudDispatch} />}
            {crudState.viewMode === 'NEW' && <CrudNewContainer crudState={crudState} crudDispatch={crudDispatch} />}

        </div>
    );
}

function reducer(state, action) {
    switch (action.type) {
        case 'changeState':
            return { ...state, viewMode: action.data };
        case 'edit':
            return { ...state, viewMode: 'EDIT', item: action.data, backTo: action.backTo };
        case 'new':
            return { ...state, viewMode: 'NEW', item: null, backTo: action.backTo };
        case 'show':
            return { ...state, viewMode: 'SHOW', item: action.data };
        case 'list':
            return { ...state, viewMode: 'LIST', item: null };
        case 'tree':
            return { ...state, viewMode: 'TREE', item: null };
        case 'filter':
            return { ...state, filters: action.filters };
        case 'loadingOn':
            return { ...state, loading: true };
        case 'loadingOff':
            return { ...state, loading: false };
        default:
            return state;
    }
}
